import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConstantsService {
    public languages: any = { fieldElements: [] };

    constructor(private http: HttpClient) {}

    loadLanguages(): Promise<void> {
        return this.http.get<any[]>('/core/js/i18n/languages.json')
            .toPromise()
            .then(langs => { this.languages = { fieldElements: langs }; })
            .catch(() => {});
    }
    
    public timezones: any = {
        fieldElements: [
            { "label": "Africa/Abidjan", "id": "Africa/Abidjan" }, {
                "label": "Africa/Accra",
                "id": "Africa/Accra"
            }, { "label": "Africa/Addis_Ababa", "id": "Africa/Addis_Ababa" }, {
                "label": "Africa/Algiers",
                "id": "Africa/Algiers"
            }, { "label": "Africa/Asmara", "id": "Africa/Asmara" }, {
                "label": "Africa/Asmera",
                "id": "Africa/Asmera"
            }, { "label": "Africa/Bamako", "id": "Africa/Bamako" }, {
                "label": "Africa/Bangui",
                "id": "Africa/Bangui"
            }, { "label": "Africa/Banjul", "id": "Africa/Banjul" }, {
                "label": "Africa/Bissau",
                "id": "Africa/Bissau"
            },
            { "label": "Africa/Blantyre", "id": "Africa/Blantyre" }, {
                "label": "Africa/Brazzaville",
                "id": "Africa/Brazzaville"
            }, { "label": "Africa/Bujumbura", "id": "Africa/Bujumbura" }, {
                "label": "Africa/Cairo",
                "id": "Africa/Cairo"
            }, { "label": "Africa/Casablanca", "id": "Africa/Casablanca" }, {
                "label": "Africa/Ceuta",
                "id": "Africa/Ceuta"
            }, { "label": "Africa/Conakry", "id": "Africa/Conakry" }, {
                "label": "Africa/Dakar",
                "id": "Africa/Dakar"
            }, { "label": "Africa/Dar_es_Salaam", "id": "Africa/Dar_es_Salaam" }, {
                "label": "Africa/Djibouti",
                "id": "Africa/Djibouti"
            },
            { "label": "Africa/Douala", "id": "Africa/Douala" }, {
                "label": "Africa/El_Aaiun",
                "id": "Africa/El_Aaiun"
            }, { "label": "Africa/Freetown", "id": "Africa/Freetown" }, {
                "label": "Africa/Gaborone",
                "id": "Africa/Gaborone"
            }, { "label": "Africa/Harare", "id": "Africa/Harare" }, {
                "label": "Africa/Johannesburg",
                "id": "Africa/Johannesburg"
            }, { "label": "Africa/Juba", "id": "Africa/Juba" }, {
                "label": "Africa/Kampala",
                "id": "Africa/Kampala"
            }, { "label": "Africa/Khartoum", "id": "Africa/Khartoum" }, {
                "label": "Africa/Kigali",
                "id": "Africa/Kigali"
            },
            { "label": "Africa/Kinshasa", "id": "Africa/Kinshasa" }, {
                "label": "Africa/Lagos",
                "id": "Africa/Lagos"
            }, { "label": "Africa/Libreville", "id": "Africa/Libreville" }, {
                "label": "Africa/Lome",
                "id": "Africa/Lome"
            }, { "label": "Africa/Luanda", "id": "Africa/Luanda" }, {
                "label": "Africa/Lubumbashi",
                "id": "Africa/Lubumbashi"
            }, { "label": "Africa/Lusaka", "id": "Africa/Lusaka" }, {
                "label": "Africa/Malabo",
                "id": "Africa/Malabo"
            }, { "label": "Africa/Maputo", "id": "Africa/Maputo" }, {
                "label": "Africa/Maseru",
                "id": "Africa/Maseru"
            },
            { "label": "Africa/Mbabane", "id": "Africa/Mbabane" }, {
                "label": "Africa/Mogadishu",
                "id": "Africa/Mogadishu"
            }, { "label": "Africa/Monrovia", "id": "Africa/Monrovia" }, {
                "label": "Africa/Nairobi",
                "id": "Africa/Nairobi"
            }, { "label": "Africa/Ndjamena", "id": "Africa/Ndjamena" }, {
                "label": "Africa/Niamey",
                "id": "Africa/Niamey"
            }, { "label": "Africa/Nouakchott", "id": "Africa/Nouakchott" }, {
                "label": "Africa/Ouagadougou",
                "id": "Africa/Ouagadougou"
            }, { "label": "Africa/Porto-Novo", "id": "Africa/Porto-Novo" },
            { "label": "Africa/Sao_Tome", "id": "Africa/Sao_Tome" }, {
                "label": "Africa/Timbuktu",
                "id": "Africa/Timbuktu"
            }, { "label": "Africa/Tripoli", "id": "Africa/Tripoli" }, {
                "label": "Africa/Tunis",
                "id": "Africa/Tunis"
            }, { "label": "Africa/Windhoek", "id": "Africa/Windhoek" }, {
                "label": "America/Adak",
                "id": "America/Adak"
            }, { "label": "America/Anchorage", "id": "America/Anchorage" }, {
                "label": "America/Anguilla",
                "id": "America/Anguilla"
            }, { "label": "America/Antigua", "id": "America/Antigua" },
            {
                "label": "America/Argentina/Buenos_Aires",
                "id": "America/Argentina/Buenos_Aires"
            }, {
                "label": "America/Argentina/Catamarca",
                "id": "America/Argentina/Catamarca"
            }, {
                "label": "America/Argentina/ComodRivadavia",
                "id": "America/Argentina/ComodRivadavia"
            }, {
                "label": "America/Argentina/Cordoba",
                "id": "America/Argentina/Cordoba"
            }, {
                "label": "America/Argentina/Jujuy",
                "id": "America/Argentina/Jujuy"
            }, { "label": "America/Argentina/La_Rioja", "id": "America/Argentina/La_Rioja" },
            {
                "label": "America/Argentina/Mendoza",
                "id": "America/Argentina/Mendoza"
            }, {
                "label": "America/Argentina/Rio_Gallegos",
                "id": "America/Argentina/Rio_Gallegos"
            }, {
                "label": "America/Argentina/Salta",
                "id": "America/Argentina/Salta"
            }, {
                "label": "America/Argentina/San_Juan",
                "id": "America/Argentina/San_Juan"
            }, {
                "label": "America/Argentina/San_Luis",
                "id": "America/Argentina/San_Luis"
            }, { "label": "America/Argentina/Tucuman", "id": "America/Argentina/Tucuman" },
            {
                "label": "America/Argentina/Ushuaia",
                "id": "America/Argentina/Ushuaia"
            }, { "label": "America/Aruba", "id": "America/Aruba" }, {
                "label": "America/Asuncion",
                "id": "America/Asuncion"
            }, { "label": "America/Atikokan", "id": "America/Atikokan" }, {
                "label": "America/Atka",
                "id": "America/Atka"
            }, {
                "label": "America/Bahia_Banderas",
                "id": "America/Bahia_Banderas"
            }, { "label": "America/Barbados", "id": "America/Barbados" }, {
                "label": "America/Belize",
                "id": "America/Belize"
            },
            { "label": "America/Blanc-Sablon", "id": "America/Blanc-Sablon" }, {
                "label": "America/Bogota",
                "id": "America/Bogota"
            }, { "label": "America/Boise", "id": "America/Boise" }, {
                "label": "America/Buenos_Aires",
                "id": "America/Buenos_Aires"
            }, { "label": "America/Cambridge_Bay", "id": "America/Cambridge_Bay" }, {
                "label": "America/Cancun",
                "id": "America/Cancun"
            }, { "label": "America/Caracas", "id": "America/Caracas" }, {
                "label": "America/Catamarca",
                "id": "America/Catamarca"
            }, { "label": "America/Cayman", "id": "America/Cayman" },
            { "label": "America/Chicago", "id": "America/Chicago" }, {
                "label": "America/Chihuahua",
                "id": "America/Chihuahua"
            }, { "label": "America/Coral_Harbour", "id": "America/Coral_Harbour" }, {
                "label": "America/Cordoba",
                "id": "America/Cordoba"
            }, { "label": "America/Costa_Rica", "id": "America/Costa_Rica" }, {
                "label": "America/Creston",
                "id": "America/Creston"
            }, { "label": "America/Curacao", "id": "America/Curacao" }, {
                "label": "America/Danmarkshavn",
                "id": "America/Danmarkshavn"
            }, { "label": "America/Dawson", "id": "America/Dawson" },
            { "label": "America/Dawson_Creek", "id": "America/Dawson_Creek" }, {
                "label": "America/Denver",
                "id": "America/Denver"
            }, { "label": "America/Detroit", "id": "America/Detroit" }, {
                "label": "America/Dominica",
                "id": "America/Dominica"
            }, { "label": "America/Edmonton", "id": "America/Edmonton" }, {
                "label": "America/El_Salvador",
                "id": "America/El_Salvador"
            }, { "label": "America/Ensenada", "id": "America/Ensenada" }, {
                "label": "America/Fort_Nelson",
                "id": "America/Fort_Nelson"
            }, { "label": "America/Fort_Wayne", "id": "America/Fort_Wayne" },
            { "label": "America/Glace_Bay", "id": "America/Glace_Bay" }, {
                "label": "America/Goose_Bay",
                "id": "America/Goose_Bay"
            }, { "label": "America/Grand_Turk", "id": "America/Grand_Turk" }, {
                "label": "America/Grenada",
                "id": "America/Grenada"
            }, { "label": "America/Guadeloupe", "id": "America/Guadeloupe" }, {
                "label": "America/Guatemala",
                "id": "America/Guatemala"
            }, { "label": "America/Guayaquil", "id": "America/Guayaquil" }, {
                "label": "America/Halifax",
                "id": "America/Halifax"
            }, { "label": "America/Havana", "id": "America/Havana" },
            {
                "label": "America/Hermosillo",
                "id": "America/Hermosillo"
            }, {
                "label": "America/Indiana/Indianapolis",
                "id": "America/Indiana/Indianapolis"
            }, {
                "label": "America/Indiana/Knox",
                "id": "America/Indiana/Knox"
            }, {
                "label": "America/Indiana/Marengo",
                "id": "America/Indiana/Marengo"
            }, {
                "label": "America/Indiana/Petersburg",
                "id": "America/Indiana/Petersburg"
            }, {
                "label": "America/Indiana/Tell_City",
                "id": "America/Indiana/Tell_City"
            }, { "label": "America/Indiana/Vevay", "id": "America/Indiana/Vevay" },
            {
                "label": "America/Indiana/Vincennes",
                "id": "America/Indiana/Vincennes"
            }, {
                "label": "America/Indiana/Winamac",
                "id": "America/Indiana/Winamac"
            }, { "label": "America/Indianapolis", "id": "America/Indianapolis" }, {
                "label": "America/Inuvik",
                "id": "America/Inuvik"
            }, { "label": "America/Iqaluit", "id": "America/Iqaluit" }, {
                "label": "America/Jamaica",
                "id": "America/Jamaica"
            }, { "label": "America/Jujuy", "id": "America/Jujuy" }, {
                "label": "America/Juneau",
                "id": "America/Juneau"
            },
            {
                "label": "America/Kentucky/Louisville",
                "id": "America/Kentucky/Louisville"
            }, {
                "label": "America/Kentucky/Monticello",
                "id": "America/Kentucky/Monticello"
            }, { "label": "America/Knox_IN", "id": "America/Knox_IN" }, {
                "label": "America/Kralendijk",
                "id": "America/Kralendijk"
            }, { "label": "America/La_Paz", "id": "America/La_Paz" }, {
                "label": "America/Los_Angeles",
                "id": "America/Los_Angeles"
            }, { "label": "America/Louisville", "id": "America/Louisville" }, {
                "label": "America/Lower_Princes",
                "id": "America/Lower_Princes"
            },
            { "label": "America/Managua", "id": "America/Managua" }, {
                "label": "America/Marigot",
                "id": "America/Marigot"
            }, { "label": "America/Martinique", "id": "America/Martinique" }, {
                "label": "America/Matamoros",
                "id": "America/Matamoros"
            }, { "label": "America/Mazatlan", "id": "America/Mazatlan" }, {
                "label": "America/Mendoza",
                "id": "America/Mendoza"
            }, { "label": "America/Menominee", "id": "America/Menominee" }, {
                "label": "America/Merida",
                "id": "America/Merida"
            }, { "label": "America/Metlakatla", "id": "America/Metlakatla" },
            { "label": "America/Mexico_City", "id": "America/Mexico_City" }, {
                "label": "America/Miquelon",
                "id": "America/Miquelon"
            }, { "label": "America/Moncton", "id": "America/Moncton" }, {
                "label": "America/Monterrey",
                "id": "America/Monterrey"
            }, { "label": "America/Montevideo", "id": "America/Montevideo" }, {
                "label": "America/Montreal",
                "id": "America/Montreal"
            }, { "label": "America/Montserrat", "id": "America/Montserrat" }, {
                "label": "America/Nassau",
                "id": "America/Nassau"
            }, { "label": "America/New_York", "id": "America/New_York" },
            { "label": "America/Nipigon", "id": "America/Nipigon" }, {
                "label": "America/Nome",
                "id": "America/Nome"
            }, {
                "label": "America/North_Dakota/Beulah",
                "id": "America/North_Dakota/Beulah"
            }, {
                "label": "America/North_Dakota/Center",
                "id": "America/North_Dakota/Center"
            }, {
                "label": "America/North_Dakota/New_Salem",
                "id": "America/North_Dakota/New_Salem"
            }, { "label": "America/Ojinaga", "id": "America/Ojinaga" }, {
                "label": "America/Panama",
                "id": "America/Panama"
            }, { "label": "America/Pangnirtung", "id": "America/Pangnirtung" },
            { "label": "America/Paramaribo", "id": "America/Paramaribo" }, {
                "label": "America/Phoenix",
                "id": "America/Phoenix"
            }, {
                "label": "America/Port-au-Prince",
                "id": "America/Port-au-Prince"
            }, {
                "label": "America/Port_of_Spain",
                "id": "America/Port_of_Spain"
            }, { "label": "America/Puerto_Rico", "id": "America/Puerto_Rico" }, {
                "label": "America/Punta_Arenas",
                "id": "America/Punta_Arenas"
            }, { "label": "America/Rainy_River", "id": "America/Rainy_River" }, {
                "label": "America/Rankin_Inlet",
                "id": "America/Rankin_Inlet"
            },
            { "label": "America/Regina", "id": "America/Regina" }, {
                "label": "America/Resolute",
                "id": "America/Resolute"
            }, { "label": "America/Rosario", "id": "America/Rosario" }, {
                "label": "America/Santa_Isabel",
                "id": "America/Santa_Isabel"
            }, { "label": "America/Santiago", "id": "America/Santiago" }, {
                "label": "America/Santo_Domingo",
                "id": "America/Santo_Domingo"
            }, { "label": "America/Shiprock", "id": "America/Shiprock" }, {
                "label": "America/Sitka",
                "id": "America/Sitka"
            }, { "label": "America/St_Barthelemy", "id": "America/St_Barthelemy" },
            { "label": "America/St_Johns", "id": "America/St_Johns" }, {
                "label": "America/St_Kitts",
                "id": "America/St_Kitts"
            }, { "label": "America/St_Lucia", "id": "America/St_Lucia" }, {
                "label": "America/St_Thomas",
                "id": "America/St_Thomas"
            }, { "label": "America/St_Vincent", "id": "America/St_Vincent" }, {
                "label": "America/Swift_Current",
                "id": "America/Swift_Current"
            }, { "label": "America/Tegucigalpa", "id": "America/Tegucigalpa" }, {
                "label": "America/Thule",
                "id": "America/Thule"
            }, { "label": "America/Thunder_Bay", "id": "America/Thunder_Bay" },
            { "label": "America/Tijuana", "id": "America/Tijuana" }, {
                "label": "America/Toronto",
                "id": "America/Toronto"
            }, { "label": "America/Tortola", "id": "America/Tortola" }, {
                "label": "America/Vancouver",
                "id": "America/Vancouver"
            }, { "label": "America/Virgin", "id": "America/Virgin" }, {
                "label": "America/Whitehorse",
                "id": "America/Whitehorse"
            }, { "label": "America/Winnipeg", "id": "America/Winnipeg" }, {
                "label": "America/Yakutat",
                "id": "America/Yakutat"
            }, { "label": "America/Yellowknife", "id": "America/Yellowknife" },
            { "label": "Antarctica/Macquarie", "id": "Antarctica/Macquarie" }, {
                "label": "Antarctica/McMurdo",
                "id": "Antarctica/McMurdo"
            }, {
                "label": "Antarctica/South_Pole",
                "id": "Antarctica/South_Pole"
            }, { "label": "Arctic/Longyearbyen", "id": "Arctic/Longyearbyen" }, {
                "label": "Asia/Amman",
                "id": "Asia/Amman"
            }, { "label": "Asia/Baghdad", "id": "Asia/Baghdad" }, {
                "label": "Asia/Bangkok",
                "id": "Asia/Bangkok"
            }, { "label": "Asia/Beirut", "id": "Asia/Beirut" }, { "label": "Asia/Calcutta", "id": "Asia/Calcutta" },
            { "label": "Asia/Chongqing", "id": "Asia/Chongqing" }, {
                "label": "Asia/Chungking",
                "id": "Asia/Chungking"
            }, { "label": "Asia/Colombo", "id": "Asia/Colombo" }, {
                "label": "Asia/Dacca",
                "id": "Asia/Dacca"
            }, { "label": "Asia/Damascus", "id": "Asia/Damascus" }, {
                "label": "Asia/Dhaka",
                "id": "Asia/Dhaka"
            }, { "label": "Asia/Famagusta", "id": "Asia/Famagusta" }, {
                "label": "Asia/Gaza",
                "id": "Asia/Gaza"
            }, { "label": "Asia/Harbin", "id": "Asia/Harbin" }, {
                "label": "Asia/Hebron",
                "id": "Asia/Hebron"
            }, { "label": "Asia/Ho_Chi_Minh", "id": "Asia/Ho_Chi_Minh" },
            { "label": "Asia/Hong_Kong", "id": "Asia/Hong_Kong" }, {
                "label": "Asia/Irkutsk",
                "id": "Asia/Irkutsk"
            }, { "label": "Asia/Istanbul", "id": "Asia/Istanbul" }, {
                "label": "Asia/Jakarta",
                "id": "Asia/Jakarta"
            }, { "label": "Asia/Jayapura", "id": "Asia/Jayapura" }, {
                "label": "Asia/Jerusalem",
                "id": "Asia/Jerusalem"
            }, { "label": "Asia/Karachi", "id": "Asia/Karachi" }, {
                "label": "Asia/Kolkata",
                "id": "Asia/Kolkata"
            }, { "label": "Asia/Kuala_Lumpur", "id": "Asia/Kuala_Lumpur" }, {
                "label": "Asia/Macao",
                "id": "Asia/Macao"
            },
            { "label": "Asia/Macau", "id": "Asia/Macau" }, {
                "label": "Asia/Makassar",
                "id": "Asia/Makassar"
            }, { "label": "Asia/Nicosia", "id": "Asia/Nicosia" }, {
                "label": "Asia/Phnom_Penh",
                "id": "Asia/Phnom_Penh"
            }, { "label": "Asia/Pontianak", "id": "Asia/Pontianak" }, {
                "label": "Asia/Pyongyang",
                "id": "Asia/Pyongyang"
            }, { "label": "Asia/Rangoon", "id": "Asia/Rangoon" }, {
                "label": "Asia/Saigon",
                "id": "Asia/Saigon"
            }, { "label": "Asia/Seoul", "id": "Asia/Seoul" }, { "label": "Asia/Shanghai", "id": "Asia/Shanghai" },
            { "label": "Asia/Singapore", "id": "Asia/Singapore" }, {
                "label": "Asia/Taipei",
                "id": "Asia/Taipei"
            }, { "label": "Asia/Tbilisi", "id": "Asia/Tbilisi" }, {
                "label": "Asia/Tehran",
                "id": "Asia/Tehran"
            }, { "label": "Asia/Tel_Aviv", "id": "Asia/Tel_Aviv" }, {
                "label": "Asia/Tokyo",
                "id": "Asia/Tokyo"
            }, { "label": "Asia/Ujung_Pandang", "id": "Asia/Ujung_Pandang" }, {
                "label": "Asia/Vientiane",
                "id": "Asia/Vientiane"
            }, { "label": "Asia/Yangon", "id": "Asia/Yangon" }, {
                "label": "Asia/Yekaterinburg",
                "id": "Asia/Yekaterinburg"
            },
            { "label": "Atlantic/Azores", "id": "Atlantic/Azores" }, {
                "label": "Atlantic/Bermuda",
                "id": "Atlantic/Bermuda"
            }, { "label": "Atlantic/Canary", "id": "Atlantic/Canary" }, {
                "label": "Atlantic/Faeroe",
                "id": "Atlantic/Faeroe"
            }, { "label": "Atlantic/Faroe", "id": "Atlantic/Faroe" }, {
                "label": "Atlantic/Jan_Mayen",
                "id": "Atlantic/Jan_Mayen"
            }, { "label": "Atlantic/Madeira", "id": "Atlantic/Madeira" }, {
                "label": "Atlantic/Reykjavik",
                "id": "Atlantic/Reykjavik"
            }, { "label": "Atlantic/St_Helena", "id": "Atlantic/St_Helena" },
            { "label": "Atlantic/Stanley", "id": "Atlantic/Stanley" }, {
                "label": "Australia/ACT",
                "id": "Australia/ACT"
            }, { "label": "Australia/Adelaide", "id": "Australia/Adelaide" }, {
                "label": "Australia/Brisbane",
                "id": "Australia/Brisbane"
            }, {
                "label": "Australia/Broken_Hill",
                "id": "Australia/Broken_Hill"
            }, { "label": "Australia/Canberra", "id": "Australia/Canberra" }, {
                "label": "Australia/Currie",
                "id": "Australia/Currie"
            }, { "label": "Australia/Darwin", "id": "Australia/Darwin" }, {
                "label": "Australia/Hobart",
                "id": "Australia/Hobart"
            },
            { "label": "Australia/LHI", "id": "Australia/LHI" }, {
                "label": "Australia/Lindeman",
                "id": "Australia/Lindeman"
            }, { "label": "Australia/Lord_Howe", "id": "Australia/Lord_Howe" }, {
                "label": "Australia/Melbourne",
                "id": "Australia/Melbourne"
            }, { "label": "Australia/NSW", "id": "Australia/NSW" }, {
                "label": "Australia/North",
                "id": "Australia/North"
            }, { "label": "Australia/Perth", "id": "Australia/Perth" }, {
                "label": "Australia/Queensland",
                "id": "Australia/Queensland"
            }, { "label": "Australia/South", "id": "Australia/South" },
            { "label": "Australia/Sydney", "id": "Australia/Sydney" }, {
                "label": "Australia/Tasmania",
                "id": "Australia/Tasmania"
            }, { "label": "Australia/Victoria", "id": "Australia/Victoria" }, {
                "label": "Australia/West",
                "id": "Australia/West"
            }, { "label": "Australia/Yancowinna", "id": "Australia/Yancowinna" }, {
                "label": "Canada/Atlantic",
                "id": "Canada/Atlantic"
            }, { "label": "Canada/Central", "id": "Canada/Central" }, {
                "label": "Canada/Eastern",
                "id": "Canada/Eastern"
            }, { "label": "Canada/Mountain", "id": "Canada/Mountain" },
            { "label": "Canada/Newfoundland", "id": "Canada/Newfoundland" }, {
                "label": "Canada/Pacific",
                "id": "Canada/Pacific"
            }, { "label": "Canada/Saskatchewan", "id": "Canada/Saskatchewan" }, {
                "label": "Canada/Yukon",
                "id": "Canada/Yukon"
            }, { "label": "Chile/Continental", "id": "Chile/Continental" }, {
                "label": "Chile/EasterIsland",
                "id": "Chile/EasterIsland"
            }, { "label": "Etc/GMT", "id": "Etc/GMT" }, {
                "label": "Etc/Greenwich",
                "id": "Etc/Greenwich"
            }, { "label": "Etc/UCT", "id": "Etc/UCT" }, { "label": "Etc/UTC", "id": "Etc/UTC" },
            { "label": "Etc/Universal", "id": "Etc/Universal" }, {
                "label": "Etc/Zulu",
                "id": "Etc/Zulu"
            }, { "label": "Europe/Amsterdam", "id": "Europe/Amsterdam" }, {
                "label": "Europe/Andorra",
                "id": "Europe/Andorra"
            }, { "label": "Europe/Athens", "id": "Europe/Athens" }, {
                "label": "Europe/Belfast",
                "id": "Europe/Belfast"
            }, { "label": "Europe/Belgrade", "id": "Europe/Belgrade" }, {
                "label": "Europe/Berlin",
                "id": "Europe/Berlin"
            }, { "label": "Europe/Bratislava", "id": "Europe/Bratislava" }, {
                "label": "Europe/Brussels",
                "id": "Europe/Brussels"
            },
            { "label": "Europe/Bucharest", "id": "Europe/Bucharest" }, {
                "label": "Europe/Budapest",
                "id": "Europe/Budapest"
            }, { "label": "Europe/Busingen", "id": "Europe/Busingen" }, {
                "label": "Europe/Chisinau",
                "id": "Europe/Chisinau"
            }, { "label": "Europe/Copenhagen", "id": "Europe/Copenhagen" }, {
                "label": "Europe/Dublin",
                "id": "Europe/Dublin"
            }, { "label": "Europe/Gibraltar", "id": "Europe/Gibraltar" }, {
                "label": "Europe/Guernsey",
                "id": "Europe/Guernsey"
            }, { "label": "Europe/Helsinki", "id": "Europe/Helsinki" },
            { "label": "Europe/Isle_of_Man", "id": "Europe/Isle_of_Man" }, {
                "label": "Europe/Istanbul",
                "id": "Europe/Istanbul"
            }, { "label": "Europe/Jersey", "id": "Europe/Jersey" }, {
                "label": "Europe/Kaliningrad",
                "id": "Europe/Kaliningrad"
            }, { "label": "Europe/Kiev", "id": "Europe/Kiev" }, {
                "label": "Europe/Lisbon",
                "id": "Europe/Lisbon"
            }, { "label": "Europe/Ljubljana", "id": "Europe/Ljubljana" }, {
                "label": "Europe/London",
                "id": "Europe/London"
            }, { "label": "Europe/Luxembourg", "id": "Europe/Luxembourg" },
            { "label": "Europe/Madrid", "id": "Europe/Madrid" }, {
                "label": "Europe/Malta",
                "id": "Europe/Malta"
            }, { "label": "Europe/Mariehamn", "id": "Europe/Mariehamn" }, {
                "label": "Europe/Minsk",
                "id": "Europe/Minsk"
            }, { "label": "Europe/Monaco", "id": "Europe/Monaco" }, {
                "label": "Europe/Moscow",
                "id": "Europe/Moscow"
            }, { "label": "Europe/Nicosia", "id": "Europe/Nicosia" }, {
                "label": "Europe/Oslo",
                "id": "Europe/Oslo"
            }, { "label": "Europe/Paris", "id": "Europe/Paris" }, {
                "label": "Europe/Podgorica",
                "id": "Europe/Podgorica"
            },
            { "label": "Europe/Prague", "id": "Europe/Prague" }, {
                "label": "Europe/Riga",
                "id": "Europe/Riga"
            }, { "label": "Europe/Rome", "id": "Europe/Rome" }, {
                "label": "Europe/San_Marino",
                "id": "Europe/San_Marino"
            }, { "label": "Europe/Sarajevo", "id": "Europe/Sarajevo" }, {
                "label": "Europe/Simferopol",
                "id": "Europe/Simferopol"
            }, { "label": "Europe/Skopje", "id": "Europe/Skopje" }, {
                "label": "Europe/Sofia",
                "id": "Europe/Sofia"
            }, { "label": "Europe/Stockholm", "id": "Europe/Stockholm" },
            { "label": "Europe/Tallinn", "id": "Europe/Tallinn" }, {
                "label": "Europe/Tirane",
                "id": "Europe/Tirane"
            }, { "label": "Europe/Tiraspol", "id": "Europe/Tiraspol" }, {
                "label": "Europe/Uzhgorod",
                "id": "Europe/Uzhgorod"
            }, { "label": "Europe/Vaduz", "id": "Europe/Vaduz" }, {
                "label": "Europe/Vatican",
                "id": "Europe/Vatican"
            }, { "label": "Europe/Vienna", "id": "Europe/Vienna" }, {
                "label": "Europe/Vilnius",
                "id": "Europe/Vilnius"
            }, { "label": "Europe/Warsaw", "id": "Europe/Warsaw" },
            { "label": "Europe/Zagreb", "id": "Europe/Zagreb" }, {
                "label": "Europe/Zaporozhye",
                "id": "Europe/Zaporozhye"
            }, { "label": "Europe/Zurich", "id": "Europe/Zurich" }, {
                "label": "GB",
                "id": "GB"
            }, { "label": "Indian/Antananarivo", "id": "Indian/Antananarivo" }, {
                "label": "Indian/Comoro",
                "id": "Indian/Comoro"
            }, { "label": "Indian/Maldives", "id": "Indian/Maldives" }, {
                "label": "Indian/Mayotte",
                "id": "Indian/Mayotte"
            }, { "label": "Mexico/BajaNorte", "id": "Mexico/BajaNorte" },
            { "label": "Mexico/BajaSur", "id": "Mexico/BajaSur" }, {
                "label": "Mexico/General",
                "id": "Mexico/General"
            }, { "label": "NZ", "id": "NZ" }, { "label": "PRC", "id": "PRC" }, {
                "label": "Pacific/Auckland",
                "id": "Pacific/Auckland"
            }, { "label": "Pacific/Bougainville", "id": "Pacific/Bougainville" }, {
                "label": "Pacific/Easter",
                "id": "Pacific/Easter"
            }, { "label": "Pacific/Guam", "id": "Pacific/Guam" }, {
                "label": "Pacific/Honolulu",
                "id": "Pacific/Honolulu"
            }, { "label": "Pacific/Johnston", "id": "Pacific/Johnston" },
            { "label": "Pacific/Midway", "id": "Pacific/Midway" }, {
                "label": "Pacific/Pago_Pago",
                "id": "Pacific/Pago_Pago"
            }, { "label": "Pacific/Port_Moresby", "id": "Pacific/Port_Moresby" }, {
                "label": "Pacific/Saipan",
                "id": "Pacific/Saipan"
            }, { "label": "Pacific/Samoa", "id": "Pacific/Samoa" }, {
                "label": "Indian/Mahoe",
                "id": "Indian/Mahoe"
            }, { "label": "ROC", "id": "ROC" }, { "label": "ROK", "id": "ROK" }, { "label": "UTC", "id": "UTC" }
        ]
    };
    
    public countries: any = {
        fieldElements: [
            { "id": "AF", "label": "Afghanistan" }, { "id": "AL", "label": "Albania" }, {
                "id": "DZ",
                "label": "Algeria"
            }, { "id": "AS", "label": "American Samoa" }, { "id": "AD", "label": "AndorrA" }, {
                "id": "AO",
                "label": "Angola"
            }, { "id": "AI", "label": "Anguilla" }, { "id": "AQ", "label": "Antarctica" }, {
                "id": "AG",
                "label": "Antigua and Barbuda"
            }, { "id": "AR", "label": "Argentina" }, { "id": "AM", "label": "Armenia" }, {
                "id": "AW",
                "label": "Aruba"
            }, { "id": "AU", "label": "Australia" },
            { "id": "AT", "label": "Austria" }, { "id": "AZ", "label": "Azerbaijan" }, {
                "id": "BS",
                "label": "Bahamas"
            }, { "id": "BH", "label": "Bahrain" }, { "id": "BD", "label": "Bangladesh" }, {
                "id": "BB",
                "label": "Barbados"
            }, { "id": "BY", "label": "Belarus" }, { "id": "BE", "label": "Belgium" }, {
                "id": "BZ",
                "label": "Belize"
            }, { "id": "BJ", "label": "Benin" }, { "id": "BM", "label": "Bermuda" }, {
                "id": "BT",
                "label": "Bhutan"
            }, { "id": "BO", "label": "Bolivia" }, { "id": "BA", "label": "Bosnia and Herzegovina" },
            { "id": "BW", "label": "Botswana" }, { "id": "BV", "label": "Bouvet Island" }, {
                "id": "BR",
                "label": "Brazil"
            }, { "id": "IO", "label": "British Indian Ocean Territory" }, {
                "id": "BN",
                "label": "Brunei Darussalam"
            }, { "id": "BG", "label": "Bulgaria" }, { "id": "BF", "label": "Burkina Faso" }, {
                "id": "BI",
                "label": "Burundi"
            }, { "id": "KH", "label": "Cambodia" }, { "id": "CM", "label": "Cameroon" }, {
                "id": "CA",
                "label": "Canada"
            }, { "id": "CV", "label": "Cape Verde" }, { "id": "KY", "label": "Cayman Islands" },
            { "id": "CF", "label": "Central African Republic" }, { "id": "TD", "label": "Chad" }, {
                "id": "CL",
                "label": "Chile"
            }, { "id": "CN", "label": "China" }, { "id": "CX", "label": "Christmas Island" }, {
                "id": "CC",
                "label": "Cocos (Keeling) Islands"
            }, { "id": "CO", "label": "Colombia" }, { "id": "KM", "label": "Comoros" }, {
                "id": "CG",
                "label": "Congo"
            }, { "id": "CD", "label": "Congo, The Democratic Republic of the" }, {
                "id": "CK",
                "label": "Cook Islands"
            }, { "id": "CR", "label": "Costa Rica" },
            { "id": "CI", "label": "Cote D'Ivoire" }, { "id": "HR", "label": "Croatia" }, {
                "id": "CU",
                "label": "Cuba"
            }, { "id": "CY", "label": "Cyprus" }, { "id": "CZ", "label": "Czech Republic" }, {
                "id": "DK",
                "label": "Denmark"
            }, { "id": "DJ", "label": "Djibouti" }, { "id": "DM", "label": "Dominica" }, {
                "id": "DO",
                "label": "Dominican Republic"
            }, { "id": "TP", "label": "East Timor" }, { "id": "EC", "label": "Ecuador" }, {
                "id": "EG",
                "label": "Egypt"
            }, { "id": "SV", "label": "El Salvador" }, { "id": "GQ", "label": "Equatorial Guinea" }, {
                "id": "ER",
                "label": "Eritrea"
            },
            { "id": "EE", "label": "Estonia" }, { "id": "ET", "label": "Ethiopia" }, {
                "id": "FK",
                "label": "Falkland Islands (Malvinas)"
            }, { "id": "FO", "label": "Faroe Islands" }, { "id": "FJ", "label": "Fiji" }, {
                "id": "FI",
                "label": "Finland"
            }, { "id": "FR", "label": "France" }, { "id": "GF", "label": "French Guiana" }, {
                "id": "PF",
                "label": "French Polynesia"
            }, { "id": "TF", "label": "French Southern Territories" }, {
                "id": "GA",
                "label": "Gabon"
            }, { "id": "GM", "label": "Gambia" }, { "id": "GE", "label": "Georgia" },
            { "id": "DE", "label": "Germany" }, { "id": "GH", "label": "Ghana" }, {
                "id": "GI",
                "label": "Gibraltar"
            }, { "id": "GR", "label": "Greece" }, { "id": "GL", "label": "Greenland" }, {
                "id": "GD",
                "label": "Grenada"
            }, { "id": "GP", "label": "Guadeloupe" }, { "id": "GU", "label": "Guam" }, {
                "id": "GT",
                "label": "Guatemala"
            }, { "id": "GG", "label": "Guernsey" }, { "id": "GN", "label": "Guinea" }, {
                "id": "GW",
                "label": "Guinea-Bissau"
            }, { "id": "GY", "label": "Guyana" }, { "id": "HT", "label": "Haiti" },
            { "id": "HM", "label": "Heard Island and Mcdonald Islands" }, {
                "id": "VA",
                "label": "Holy See (Vatican City State)"
            }, { "id": "HN", "label": "Honduras" }, { "id": "HK", "label": "Hong Kong" }, {
                "id": "HU",
                "label": "Hungary"
            }, { "id": "IS", "label": "Iceland" }, { "id": "IN", "label": "India" }, {
                "id": "ID",
                "label": "Indonesia"
            }, { "id": "IR", "label": "Iran, Islamic Republic Of" }, { "id": "IQ", "label": "Iraq" }, {
                "id": "IE",
                "label": "Ireland"
            },
            { "id": "IL", "label": "Israel" }, { "id": "IT", "label": "Italy" }, {
                "id": "JM",
                "label": "Jamaica"
            }, { "id": "JP", "label": "Japan" }, { "id": "JE", "label": "Jersey" }, {
                "id": "JO",
                "label": "Jordan"
            }, { "id": "KZ", "label": "Kazakhstan" }, { "id": "KE", "label": "Kenya" }, {
                "id": "KI",
                "label": "Kiribati"
            }, { "id": "KP", "label": "Korea, Democratic People'S Republic of" }, {
                "id": "KR",
                "label": "Korea, Republic of"
            }, { "id": "KW", "label": "Kuwait" }, { "id": "KG", "label": "Kyrgyzstan" },
            { "id": "LA", "label": "Lao People'S Democratic Republic" }, {
                "id": "LV",
                "label": "Latvia"
            }, { "id": "LB", "label": "Lebanon" }, { "id": "LS", "label": "Lesotho" }, {
                "id": "LR",
                "label": "Liberia"
            }, { "id": "LY", "label": "Libyan Arab Jamahiriya" }, {
                "id": "LI",
                "label": "Liechtenstein"
            }, { "id": "LT", "label": "Lithuania" }, { "id": "LU", "label": "Luxembourg" }, {
                "id": "MO",
                "label": "Macao"
            }, { "id": "MK", "label": "Macedonia, The Former Yugoslav Republic of" }, {
                "id": "MG",
                "label": "Madagascar"
            },
            { "id": "MW", "label": "Malawi" }, { "id": "MY", "label": "Malaysia" }, {
                "id": "MV",
                "label": "Maldives"
            }, { "id": "ML", "label": "Mali" }, { "id": "MT", "label": "Malta" }, {
                "id": "MH",
                "label": "Marshall Islands"
            }, { "id": "MQ", "label": "Martinique" }, { "id": "MR", "label": "Mauritania" }, {
                "id": "MU",
                "label": "Mauritius"
            }, { "id": "YT", "label": "Mayotte" }, { "id": "MX", "label": "Mexico" }, {
                "id": "FM",
                "label": "Micronesia, Federated States of"
            }, { "id": "MD", "label": "Moldova, Republic of" },
            { "id": "MC", "label": "Monaco" }, { "id": "MN", "label": "Mongolia" }, {
                "id": "MS",
                "label": "Montserrat"
            }, { "id": "MA", "label": "Morocco" }, { "id": "MZ", "label": "Mozambique" }, {
                "id": "MM",
                "label": "Myanmar"
            }, { "id": "NA", "label": "Namibia" }, { "id": "NR", "label": "Nauru" }, {
                "id": "NP",
                "label": "Nepal"
            }, { "id": "NL", "label": "Netherlands" }, { "id": "AN", "label": "Netherlands Antilles" }, {
                "id": "NC",
                "label": "New Caledonia"
            }, { "id": "NZ", "label": "New Zealand" }, { "id": "NI", "label": "Nicaragua" },
            { "id": "NE", "label": "Niger" }, { "id": "NG", "label": "Nigeria" }, {
                "id": "NU",
                "label": "Niue"
            }, { "id": "NF", "label": "Norfolk Island" }, {
                "id": "MP",
                "label": "Northern Mariana Islands"
            }, { "id": "NO", "label": "Norway" }, { "id": "OM", "label": "Oman" }, {
                "id": "PK",
                "label": "Pakistan"
            }, { "id": "PW", "label": "Palau" }, {
                "id": "PS",
                "label": "Palestinian Territory, Occupied"
            }, { "id": "PA", "label": "Panama" }, { "id": "PG", "label": "Papua New Guinea" }, {
                "id": "PY",
                "label": "Paraguay"
            },
            { "id": "PE", "label": "Peru" }, { "id": "PH", "label": "Philippines" }, {
                "id": "PN",
                "label": "Pitcairn"
            }, { "id": "PL", "label": "Poland" }, { "id": "PT", "label": "Portugal" }, {
                "id": "PR",
                "label": "Puerto Rico"
            }, { "id": "QA", "label": "Qatar" }, { "id": "RE", "label": "Reunion" }, {
                "id": "RO",
                "label": "Romania"
            }, { "id": "RU", "label": "Russian Federation" }, { "id": "RW", "label": "RWANDA" }, {
                "id": "SH",
                "label": "Saint Helena"
            }, { "id": "KN", "label": "Saint Kitts and Nevis" }, { "id": "LC", "label": "Saint Lucia" },
            { "id": "PM", "label": "Saint Pierre and Miquelon" }, {
                "id": "VC",
                "label": "Saint Vincent and the Grenadines"
            }, { "id": "WS", "label": "Samoa" }, { "id": "SM", "label": "San Marino" }, {
                "id": "ST",
                "label": "Sao Tome and Principe"
            }, { "id": "SA", "label": "Saudi Arabia" }, { "id": "SN", "label": "Senegal" }, {
                "id": "SC",
                "label": "Seychelles"
            }, { "id": "SL", "label": "Sierra Leone" }, { "id": "SG", "label": "Singapore" }, {
                "id": "SK",
                "label": "Slovakia"
            },
            { "id": "SI", "label": "Slovenia" }, { "id": "SB", "label": "Solomon Islands" }, {
                "id": "SO",
                "label": "Somalia"
            }, { "id": "ZA", "label": "South Africa" }, {
                "id": "GS",
                "label": "South Georgia and the South Sandwich Islands"
            }, { "id": "ES", "label": "Spain" }, { "id": "LK", "label": "Sri Lanka" }, {
                "id": "SD",
                "label": "Sudan"
            }, { "id": "SR", "label": "Suriname" }, { "id": "SJ", "label": "Svalbard and Jan Mayen" }, {
                "id": "SZ",
                "label": "Swaziland"
            }, { "id": "SE", "label": "Sweden" }, { "id": "CH", "label": "Switzerland" },
            { "id": "SY", "label": "Syrian Arab Republic" }, {
                "id": "TW",
                "label": "Taiwan, Province of China"
            }, { "id": "TJ", "label": "Tajikistan" }, {
                "id": "TZ",
                "label": "Tanzania, United Republic of"
            }, { "id": "TH", "label": "Thailand" }, { "id": "TL", "label": "Timor-Leste" }, {
                "id": "TG",
                "label": "Togo"
            }, { "id": "TK", "label": "Tokelau" }, { "id": "TO", "label": "Tonga" }, {
                "id": "TT",
                "label": "Trinidad and Tobago"
            }, { "id": "TN", "label": "Tunisia" }, { "id": "TR", "label": "Turkey" }, {
                "id": "TM",
                "label": "Turkmenistan"
            },
            { "id": "TC", "label": "Turks and Caicos Islands" }, { "id": "TV", "label": "Tuvalu" }, {
                "id": "UG",
                "label": "Uganda"
            }, { "id": "UA", "label": "Ukraine" }, { "id": "AE", "label": "United Arab Emirates" }, {
                "id": "GB",
                "label": "United Kingdom"
            }, { "id": "US", "label": "United States" }, {
                "id": "UM",
                "label": "United States Minor Outlying Islands"
            }, { "id": "UY", "label": "Uruguay" }, { "id": "UZ", "label": "Uzbekistan" }, {
                "id": "VU",
                "label": "Vanuatu"
            }, { "id": "VE", "label": "Venezuela" }, { "id": "VN", "label": "Viet Nam" },
            { "id": "VG", "label": "Virgin Islands, British" }, {
                "id": "VI",
                "label": "Virgin Islands, U.S."
            }, { "id": "WF", "label": "Wallis and Futuna" }, { "id": "EH", "label": "Western Sahara" }, {
                "id": "YE",
                "label": "Yemen"
            }, { "id": "YU", "label": "Yugoslavia" }, { "id": "ZM", "label": "Zambia" }, {
                "id": "ZW",
                "label": "Zimbabwe"
            }
        ]
    };
}